import { AccomodationEnum } from '../../types/enums/accomodation-type/accomodation-type'
import { AffectedStaffStatusEnum } from '../../types/enums/affected-staff/affected-staff-status.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { AffectedStaffFilters } from '../../types/models/affectedStaff/affected-staff-input'

export const transformAffectedStaffFiltersToUrl = (filters?: AffectedStaffFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.staffRequestId)
    searchParams.append('staffRequestId', filters.staffRequestId.toString())

  if (filters.radId) searchParams.append('radId', filters.radId.toString())

  if (filters.centerId) searchParams.append('centerId', filters.centerId.toString())

  if (filters.centerIds && filters.centerIds.length)
    searchParams.append('centerIds', filters.centerIds.join(','))

  if (filters.positions) searchParams.append('positions', filters.positions.join(','))

  if (filters.qualifications && filters.qualifications.length)
    searchParams.append('qualifications', filters.qualifications.join(','))

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  if (filters.departureDateRange?.startDate && filters.departureDateRange?.endDate) {
    searchParams.set('departureDateRangeFrom', filters.departureDateRange.startDate.toString())
    searchParams.set('departureDateRangeTo', filters.departureDateRange.endDate.toString())
  }

  if (filters.returnDateRange?.startDate && filters.returnDateRange?.endDate) {
    searchParams.set('returnDateRangeFrom', filters.returnDateRange.startDate.toString())
    searchParams.set('returnDateRangeTo', filters.returnDateRange.endDate.toString())
  }

  if (filters.assignedDateRange?.startDate && filters.assignedDateRange?.endDate) {
    searchParams.set('assignedDateRangeFrom', filters.assignedDateRange.startDate.toString())
    searchParams.set('assignedDateRangeTo', filters.assignedDateRange.endDate.toString())
  }

  if (filters.accomodations && filters.accomodations.length)
    searchParams.append('accomodations', filters.accomodations.join(','))

  if (filters.statuses) searchParams.append('statuses', filters.statuses.toString())

  if (filters.allDocumentsCompleted)
    searchParams.append('allDocumentsCompleted', filters.allDocumentsCompleted.toString())

  if (filters.hasMissingDocuments)
    searchParams.append('hasMissingDocuments', filters.hasMissingDocuments.toString())

  if (filters.isFrench !== undefined) searchParams.append('isFrench', filters.isFrench.toString())

  if (filters.trips && filters.trips.length) searchParams.append('trips', filters.trips.join(','))

  return searchParams.toString()
}

export const transformUrlToAffectedStaffFilters = (
  searchParams: URLSearchParams
): AffectedStaffFilters => {
  const filters: AffectedStaffFilters = {}

  const staffRequestId = searchParams.get('staffRequestId')
  if (staffRequestId) filters.staffRequestId = parseInt(staffRequestId)

  const radId = searchParams.get('radId')
  if (radId) filters.radId = parseInt(radId)

  const centerId = searchParams.get('centerId')
  if (centerId) filters.centerId = parseInt(centerId)

  const centerIds = searchParams.get('centerIds')
  if (centerIds && centerIds.length) filters.centerIds = centerIds.split(',').map(Number)

  const positions = searchParams.get('positions')
  if (positions) filters.positions = positions.split(',') as StaffPositionEnum[]

  const qualifications = searchParams.get('qualifications')
  if (qualifications && qualifications.length > 0)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  const countries = searchParams.get('countries')
  if (countries && countries.length > 0) filters.countries = countries.split(',')

  const formulas = searchParams.get('formulas')
  if (formulas && formulas.length > 0) filters.formulas = formulas.split(',').map(Number)

  const periods = searchParams.get('periods')
  if (periods && periods.length > 0) filters.periods = periods.split(',').map(Number)

  const departureDateRangeFrom = searchParams.get('departureDateRangeFrom')
  const departureDateRangeTo = searchParams.get('departureDateRangeTo')
  if (departureDateRangeFrom && departureDateRangeTo) {
    filters.departureDateRange = {
      startDate: departureDateRangeFrom,
      endDate: departureDateRangeTo
    }
  }

  const returnDateRangeFrom = searchParams.get('returnDateRangeFrom')
  const returnDateRangeTo = searchParams.get('returnDateRangeTo')
  if (returnDateRangeFrom && returnDateRangeTo) {
    filters.returnDateRange = {
      startDate: returnDateRangeFrom,
      endDate: returnDateRangeTo
    }
  }

  const assignedDateRangeFrom = searchParams.get('assignedDateRangeFrom')
  const assignedDateRangeTo = searchParams.get('assignedDateRangeTo')
  if (assignedDateRangeFrom && assignedDateRangeTo) {
    filters.assignedDateRange = {
      startDate: assignedDateRangeFrom,
      endDate: assignedDateRangeTo
    }
  }

  const accomodations = searchParams.get('accomodations')
  if (accomodations && accomodations.length > 0)
    filters.accomodations = accomodations.split(',') as AccomodationEnum[]

  const statuses = searchParams.get('statuses')
  if (statuses && statuses.length > 0)
    filters.statuses = statuses.split(',') as AffectedStaffStatusEnum[]

  const allDocumentsCompleted = searchParams.get('allDocumentsCompleted')
  if (allDocumentsCompleted) filters.allDocumentsCompleted = allDocumentsCompleted === 'true'

  const hasMissingDocuments = searchParams.get('hasMissingDocuments')
  if (hasMissingDocuments) filters.hasMissingDocuments = hasMissingDocuments === 'true'

  const isFrench = searchParams.get('isFrench')
  if (isFrench) filters.isFrench = isFrench === 'true'

  const trips = searchParams.get('trips')
  if (trips && trips.length > 0) filters.trips = trips.split(',').map(Number)

  return filters
}
